//スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});

//ナビゲーション用
$(function(){
	$('#gnav_btn').on('click', function(){
		if($(this).hasClass('open')){
			$(this).removeClass('open');
			$('header nav').removeClass('open').stop().slideUp(200);
			$('body').removeClass('add_overray');
		}else{
			$(this).addClass('open');
			$('header nav').addClass('open').stop().slideDown(200);
			$('body').addClass('add_overray');
		}
	});
	$('.outside').on('click', function(){
		$('#gnav_btn').removeClass('open');
		$('header nav').removeClass('open').stop().slideUp(200);
		$('body').removeClass('add_overray');
	});
});


//フェードイン
$(function(){
    $(window).scroll(function (){
        $('.fadein').each(function(){
            var elemPos = $(this).offset().top;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            if (scroll > elemPos - windowHeight + 50){
                $(this).addClass('scrollin');
            }
        });
    });
});

$(function(){
    $(window).scroll(function (){
        $('.fadein2').each(function(){
            var elemPos = $(this).offset().top;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            if (scroll > elemPos - windowHeight){
                $(this).addClass('scrollin');
            }
        });
    });
});

//画像アニメーション
$(function(){
    $('.animation_area').css("opacity","0");
    $(window).scroll(function (){
        $(".animation_area").each(function(){
            var imgPos = $(this).offset().top;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            if (scroll > imgPos - windowHeight + windowHeight/5){
                $(this).css("opacity","1");
				$(this).find('.key_3').addClass('dummy_area3');
                $(this).find('.key_2').addClass('dummy_area');
                $(this).find('.key_1').addClass('img_area');
            }
        });
    });
});

//高さ
$(function() {
    $('.match').matchHeight();
});
$(function() {
    $('.match2').matchHeight();
});
$(function() {
    $('.match3').matchHeight();
});
$(function() {
    $('.match4').matchHeight();
});

//SVG
window.addEventListener('load', function(){
  deSVG('.svg', true);
});

///アコーディオン
$(function() {
  var $accBtn = $('.Acbtn'),
      $accContents = $('.Accontents');
  
  $accContents.hide(); //contentsを全て隠す
  $accBtn.each(function() {
    var flag = "close"; //flagを初期値を設定
    $(this).click(function(e) {
      e.preventDefault(); //aタグのリンク無効化
      $(this).prev().slideToggle(); //すぐ次の要素をスライド

      if(flag == "close"){ //もしflagがcloseだったら
        $(this).text("Close").addClass('open').removeClass('close');
        flag = "open"; //flagをopenにする
      }
      else{ //もしflagがopenだったら
        $(this).text("See more").addClass('close').removeClass('open');
        flag = "close"; //flagをcloseにする
      }

    });
  });
});

$('.multiple').slick({
    autoplay: true, //自動再生
    infinite: true, //スライドのループ有効化
	draggable: true,
	arrows: true,
    slidesToShow: 4, //表示するスライドの数
    slidesToScroll: 4, //スクロールで切り替わるスライドの数
    responsive: [{
      breakpoint: 768, //ブレークポイントが768px
      settings: {
        slidesToShow: 2, //表示するスライドの数
        slidesToScroll: 2, //スクロールで切り替わるスライドの数
      }
    }]
  });